import { render, staticRenderFns } from "./EditBusinessMemberPrescriptionMedications.vue?vue&type=template&id=417a8997"
import script from "./EditBusinessMemberPrescriptionMedications.vue?vue&type=script&lang=js"
export * from "./EditBusinessMemberPrescriptionMedications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports